












































































import Vue from 'vue'

import { ProductCardModel, ProductSkuDetail } from '@/search/types'
import ProductCardTextInfo from '@/common/components/productCard/ProductCardTextInfo.vue'
import BaseImage from '@/common/components/BaseImage.vue'
import NativeBaseImage from '@/common/components/NativeBaseImage.vue'
import FastShippingLabel from '@/common/components/FastShippingLabel.vue'
import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES } from '@/common/constants'
import { formatOneDecimal } from '@/common/utils/common'

export default Vue.extend({
  components: {
    BaseImage,
    NativeBaseImage,
    ProductCardTextInfo,
    FastShippingLabel
  },
  props: {
    product: {
      type: Object as () => ProductCardModel,
      required: true
    },
    productUrl: {
      type: String,
      default: ''
    },
    useNativeLazy: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    showFull: boolean
    mainSku: ProductSkuDetail
    isShowPlaceholder: boolean
    defaultProductUrl: string
    isFirstSkuImage: boolean
    cardWidth: number
  } {
    return {
      showFull: false,
      mainSku: this.product.skuDetails[0],
      isShowPlaceholder: true,
      defaultProductUrl: this.product.url,
      isFirstSkuImage: true,
      cardWidth: 0
    }
  },

  computed: {
    MAX_DISPLAY_SKU(): number {
      if (window.innerWidth < 1024) {
        return this.cardWidth < 150 ? 3 : 4
      } else {
        return this.cardWidth < 150 ? 3 : 5
      }
    },
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    numberOfSku(): number {
      return this.product.skuDetails.length
    },
    numberDisplaySku(): number {
      return this.showFull ? this.numberOfSku : this.MAX_DISPLAY_SKU
    },
    displaySkus(): ProductSkuDetail[] {
      return this.product.skuDetails.slice(0, this.numberDisplaySku)
    },
    remainingSku(): number {
      return this.numberOfSku - this.displaySkus.length
    },
    firstImageSku(): string {
      return this.product.skuDetails[0]?.skuImage || ''
    },
    productPageUrl(): string {
      return this.productUrl || this.defaultProductUrl
    }
  },
  watch: {
    firstImageSku(newVal) {
      if (newVal) {
        this.mainSku = this.product.skuDetails[0]
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.cardWidth = (this.$el as HTMLElement).offsetWidth
    })
  },
  methods: {
    formatOneDecimal,
    onChangeMainSku(sku: ProductSkuDetail) {
      this.isFirstSkuImage = false
      this.mainSku = sku
      this.isShowPlaceholder = false
      this.defaultProductUrl = this.product.url + `?psi=${this.mainSku.psi}`
      this.$emit('updatePsi', this.mainSku.psi)
    }
  }
})
